
//******************Exchange Rate Server Calls******************;

import {CouponImageListActions} from './CouponImageListConstants';

import store from '../../../Store/store'
import {ROOT_URL,getCookie} from '../../../Config/Config';
import {failure_messages} from "Messages"


export const CouponImageListServer = {
  //  getCouponImageList:getCouponImageList,
  getCouponImageList:getCouponImageList,
  getCouponImageLimits:getCouponImageLimits
  //  updateCouponImageList:updateCouponImageList
};

//******************Insert CouponImageLists******************;

function getCouponImageLimits(data){
  // alert(JSON.stringify(data))
  const request=fetch(ROOT_URL+'/api/coupons/getAllCouponImages', {
      method: 'Post',
      mode: 'cors',
      headers: { 
        'authorization':getCookie("admin_token_partner"),
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
      }).then((response)=>{
       response.json().then(response=>{
         if(response.status == "200"){
         alert(JSON.stringify(response))
        store.dispatch({type:CouponImageListActions.CouponImageList_GET.SUCCESS,payload:response.data});
        return ;
        }else
        {
          store.dispatch({type:CouponImageListActions.CouponImageList_GET.FAILED, error:response.error});
          return ;
          }    
       });
      }).catch((error) => {
      //  alert(error)
       store.dispatch({type:CouponImageListActions.CouponImageList_GET.FAILED, error:failure_messages.Businessparticipants});
        })
  return {type:CouponImageListActions.CouponImageList_GET.LOADING}

};

function getCouponImageList(){
      // alert(JSON.stringify(data))
      const request=fetch(ROOT_URL+'/api/coupons/getAllCouponImages', {
          method: 'Post',
          mode: 'cors',
          headers: { 
            'authorization':getCookie("admin_token_partner"),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          // body: JSON.stringify(data)
          }).then((response)=>{
           response.json().then(response=>{
             if(response.status == "200"){
             // alert(JSON.stringify(response))
            store.dispatch({type:CouponImageListActions.CouponImageList_GET.SUCCESS,payload:response.data});
            return ;
            }else
            {
              store.dispatch({type:CouponImageListActions.CouponImageList_GET.FAILED, error:response.error});
              return ;
              }    
           });
          }).catch((error) => {
          //  alert(error)
           store.dispatch({type:CouponImageListActions.CouponImageList_GET.FAILED, error:failure_messages.Businessparticipants});
            })
      return {type:CouponImageListActions.CouponImageList_GET.LOADING}

};
  
//******************Get CouponImageLists******************;


//******************Update CouponImageList******************;

  
// function getCouponImageList(){
//       const request=fetch(ROOT_URL+'/api/exchangeRate/getExchangeRate/', {
//           method: 'GET',
//           mode: 'cors',
//           headers: {'Content-Type':'application/json'},
//          // body: JSON.stringify(data)
//           }).then((response)=>{
//             response.json().then(response=>{
//               if(response.status == "200"){
//                 console.log(response)
//                 if(response.CouponImageList.length>0)
//              store.dispatch({type:CouponImageListActions.CouponImageList_Get.SUCCESS,payload:response.CouponImageList});
//              else
//              store.dispatch({type:CouponImageListActions.CouponImageList_GET.NEW});
             
//              return ;
//              }else
//              {
//                store.dispatch({type:CouponImageListActions.CouponImageList_Get.FAILED});
//                return ;
//                }    
//             });
//            }).catch((error) => {
//             store.dispatch({type:CouponImageListActions.CouponImageList_Get.FAILED});
//           })
//        return {type:CouponImageListActions.CouponImageList_GET.LOADING}
 
//     };
  
// function updateCouponImageList(data){
//   const request=fetch(ROOT_URL+'/api/exchangeRate/BulkUpdateExchangeRate', {
//     method: 'Post',
//     mode: 'cors',
//     headers: {'Content-Type':'application/json'},
//     body: JSON.stringify(data)
//     }).then((response)=>{
//      response.json().then(response=>{
//        if(response.status == "200"){
//          console.log(response)
//       store.dispatch({type:CouponImageListActions.CouponImageList_GET.SUCCESS});
//       return ;
//       }else
//       {
//         store.dispatch({type:CouponImageListActions.CouponImageList_GET.FAILED});
//         return ;
//         }    
//      });
//     }).catch((error) => {
//       store.dispatch({type:CouponImageListActions.CouponImageList_GET.FAILED});
//     })
// return {type:CouponImageListActions.CouponImageList_GET.LOADING}

// };
